import CloseIcon from "@mui/icons-material/Close";
import { Drawer as DrawerMui, Grid } from "@mui/material";
import { themeBBJ } from "@style/theme/material.theme";
import { forwardRef } from "react";
import { CloseIconButton, DrawerContentContainerGrid, DrawerContentGrid } from "./styles";

/**
 *
 * @param {String} props.id Div identification
 * @param {String} props.isOpen Drawer is open or not
 * @param {String} props.setOpen change Isopen state
 * @param {String} props.TitleComponent Component used for top left title
 * @param {String} props.anchor where to show the drawer (right, left, top, bottom) right by default
 */
export const Drawer = forwardRef(function Drawer(
  {
    id,
    anchor = "right",
    isOpen = false,
    setOpen,
    onClose,
    TitleComponent,
    PaperProps,
    PaperContentProps,
    titleWrapperProps = {},
    children,
    scrollRef,
    ...props
  },
  ref
) {
  /**
   * @Methods
   */
  const handleClose = () => {
    if (typeof onClose === "function") {
      onClose();
    }
    if (typeof setOpen === "function") {
      setOpen(false);
    }
  };

  return (
    <DrawerMui
      ref={ref}
      id={id}
      data-testid={id}
      anchor={anchor}
      open={isOpen}
      onClose={handleClose}
      {...props}
      ModalProps={{
        sx: { top: themeBBJ.navbarSize },
      }}
      slotProps={{
        paper: {
          id: `${id}-paper`,
          sx: {
            top: themeBBJ.navbarSize,
            height: `calc(100% - ${themeBBJ.navbarSize})`,
          },
          ...PaperProps,
        },
      }}
    >
      <Grid container {...titleWrapperProps} className={titleWrapperProps.className}>
        <Grid id={`${id}-title`} size={10}>
          {TitleComponent && <TitleComponent />}
        </Grid>
        <Grid
          container
          sx={{
            justifyContent: "flex-end",
          }}
          size={2}>
          <CloseIconButton onClick={handleClose} alt="Close" size="small" data-testid="drawer-close-button">
            <CloseIcon />
          </CloseIconButton>
        </Grid>
      </Grid>
      <DrawerContentContainerGrid container className={`${PaperContentProps?.className}`}>
        <DrawerContentGrid
          id={`${id}-paper-content`}
          ref={scrollRef}
          container
          {...PaperContentProps}
          className={`${PaperContentProps?.className}`}
        >
          {children}
        </DrawerContentGrid>
      </DrawerContentContainerGrid>
    </DrawerMui>
  );
});
